import React from 'react';
import { CalcitePanel } from "@esri/calcite-components-react";


const GenericFooter = () => {

	return ( <CalcitePanel slot="footer" style={{margin:'auto .5rem'}} >
		<div style={{width:'100%'}}>Copyright (&copy; {new Date().getFullYear()}) Rutgers, The State University of New Jersey</div>
		<div> Rutgers is an equal access/equal opportunity institution. Individuals with disabilities are encouraged to direct suggestions, comments, or complaints concerning any accessibility issues with Rutgers websites to accessibility@rutgers.edu or complete the <a href="https://it.rutgers.edu/it-accessibility-initiative/barrierform/">Report Accessibility Barrier / Provide Feedback Form</a>.</div>
	</CalcitePanel> );
}

//Copyright (&copy; {new Date().getFullYear()}) Rutgers, The State University of New Jersey <br />
export default GenericFooter;